import React from 'react'

import ConfirmationDetails from './Common/ConfirmationDetails'
import Divider from './Common/Divider'
import ItemTypeAndBookedLabel from './Common/ItemTypeAndBookedLabel'
import LocationAndAddressWithMap from './Common/LocationAndAddressWithMap'
import StartAndEndDateTime from './Common/StartAndEndDateTime'
import SummaryAdditionalNotes from './Common/SummaryAdditionalNotes'
import SummaryDataItem from './Common/SummaryDataItem'
import DefaultSummaryModalFooter from './Common/SummaryModalFooter/DefaultSummaryModalFooter'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import { TransportItem } from 'tripPlanner/types/tripItem'

interface Props {
  transportName: string
  item: TransportItem
}

function BaseTransportSummary(props: Props) {
  const { item, transportName } = props

  const { closeModal, goBack } = useModalCallbacks()

  return (
    <>
      <ModalHeader
        title={`${transportName} from ${item.startPlace.name} to ${item.endPlace.name}`}
        subtitle={item.operatorName}
        onCloseButtonClick={closeModal}
        onBackButtonClick={goBack}
      />

      <ModalBody>
        <ModalContent>
          <VerticalSpacer gap={20}>
            <ItemTypeAndBookedLabel item={item} />
            <StartAndEndDateTime
              startTitle="Departure"
              endTitle="Arrival"
              item={item}
            />
          </VerticalSpacer>
          <Divider />
          <LocationAndAddressWithMap
            item={item}
            place={item.startPlace}
            placeTitle="Origin location"
          />
          <Divider />
          <LocationAndAddressWithMap
            item={item}
            place={item.endPlace}
            placeTitle="Destination location"
          />
          <ConfirmationDetails
            isBooked={item.isBooked}
            confirmationCode={item.confirmationCode}
            price={item.price}
          />
          <Divider />
          <SummaryDataItem title="Seat" value={item.seat} />
          <Divider />
          <VerticalSpacer gap={20}>
            <SummaryDataItem title="Website" value={item.url} url={item.url} />
            <SummaryAdditionalNotes notes={item.notes} />
          </VerticalSpacer>
        </ModalContent>
      </ModalBody>

      <DefaultSummaryModalFooter item={item} />
    </>
  )
}

export default BaseTransportSummary
